import { getAccessTokenAPI } from "../api/config/getAccessToken";
import { ENVIRONMENT_TYPE } from "../constant/common";
import { environment } from "../constant/environment";
import { decryptData } from "./api/encryption";
import { isValidJWT } from "./authentication/isValidJWT";
import { consoleLog } from "./consoleLog/consoleLog";

export async function clearAllLocalSessionStorageThenRefresh(setAccessJWT: any) {
  try {
    const localAccessJWT = localStorage.getItem("_zenvoya_access_JWT");
    consoleLog(["JWT Check First", localAccessJWT]);
    let parsedJWT;
    if (localAccessJWT) {
      if (environment !== ENVIRONMENT_TYPE.LOCAL) {
        parsedJWT = decryptData(localAccessJWT);
      } else {
        parsedJWT = JSON.parse(localAccessJWT);
      }
      consoleLog(["JWT Check", isValidJWT(parsedJWT), parsedJWT]);

      if (isValidJWT(parsedJWT)) {
        // JWT is valid, no need to clear storage
        return;
      }
    }

    // Clear local & session storage
    localStorage.clear();
    sessionStorage.clear();
    console.log("All localStorage and sessionStorage data have been cleared!");

    // Get new token
    const response = await getAccessTokenAPI();
    consoleLog(["JWT Check out", response]);

    setAccessJWT(response?.data);

    // If token is invalid, reload
    window.location.reload();
  } catch (error) {
    console.error("All localStorage Error clearing storage or refreshing token:", error);
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }
}
